export enum RoutePath {
   Home = '/',
   Login = '/login',
   CashPoint = '/cash-point',
   Result = '/result',
}
